<template>
  <div>
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
    <NuxtRouteAnnouncer />
  </div>
</template>

<script setup lang="ts">
// 全局SEO配置 - 使用useHead替代useSeo避免middleware中的警告
useHead({
  title: '苏州瀚易特信息技术股份有限公司',
  meta: [
    { name: 'description', content: '瀚林愿AI成长平台，专注学生体质、心理、学情与行为数据智能分析，构建校园全场景AI数字孪生体系，助力学校精准育人与区域教育科学决策，赋能教育数字化转型。' },
    { name: 'keywords', content: 'AI成长平台 、校园安全、瀚易特、瀚林愿' },
    { name: 'author', content: '苏州瀚易特信息技术股份有限公司官网' }
  ]
})
</script>

<style>
/* 全局样式将通过nuxt.config.ts加载 */
</style>